import * as _ from 'lodash';
import { MapPersistedState } from '../../map/models/map-persisted-state';
import { Garage } from '../../shared/models/garage';
import { VehiclePunctualityConfig, VehicleWarningConfig } from '../../shared/models/vehicle';
import { SelectedFilters } from '../utilities/filter-spaces-models';
import { UserMapConfig } from './user-map-config';
import { TrafficDeviationsConfig } from '@components/traffic-deviations/models/traffic-deviations-config';

export const SELECTION_OVERVIEW_WINDOW_SMALL_WIDTH = 385;
export const SELECTION_OVERVIEW_WINDOW_LARGE_WIDTH = 500;
export const HOME_WIDGET_PANEL_MAX_WIDTH = 1010;

// Different context that the app can have and will affect how the app behaves
export enum APP_CONTEXT {
    HOME = 'HOME',
    LINE = 'LINE',
    NONE = 'NONE',
    VEHICLE = 'VEHICLE',
    PUNCTUALITY = 'PUNCTUALITY',
    WARNING = 'WARNING',
    HISTORY = 'HISTORY',
    NEW_TRAFFIC_DEVIATION = 'NEW_TRAFFIC_DEVIATION',
    TRAFFIC_DEVIATIONS = 'TRAFFIC_DEVIATIONS',
    EDIT_TRAFFIC_DEVIATION_TEMPLATES = 'EDIT_TRAFFIC_DEVIATION_TEMPLATES',
    SETTINGS = 'SETTINGS'
}

export class AppState {
    selectedContext: APP_CONTEXT;
    selectionOverviewWidthByContext: { [key: string]: string };
    selectedFilter: SelectedFilters;
    leftPanelIsVisible: boolean;
    punctualityConfig: VehiclePunctualityConfig;
    warningConfig: VehicleWarningConfig;
    mapConfig: UserMapConfig;
    mapPersistedState: MapPersistedState;
    trafficDeviationsConfig: TrafficDeviationsConfig;

    garages: Garage[] = [];
    selectedGarageCodes: string[] = [];

    leftTotalWidth = 0;

    version = '1.6';    // if new breaking-version then cannot get saved items?

    constructor() {
        // defaultValues
        this.selectedContext = APP_CONTEXT.NONE;
        this.leftPanelIsVisible = false;
        this.selectedGarageCodes = [];
        this.punctualityConfig = new VehiclePunctualityConfig();
        this.warningConfig = new VehicleWarningConfig();
        this.mapConfig = new UserMapConfig();
        this.mapPersistedState = new MapPersistedState();
        this.trafficDeviationsConfig = new TrafficDeviationsConfig();
        this.selectedFilter = {
            areaSelection: undefined,
            toggleableSelectionOptions: undefined
        };

        this.selectionOverviewWidthByContext = {};
        _.reduce(Object.keys(APP_CONTEXT), (result: { [key: string]: string }, value: string) => {
            if (value === APP_CONTEXT.EDIT_TRAFFIC_DEVIATION_TEMPLATES) {
                result[value] = `calc(100vw - var(--menu_width) - 1px)`;
                return result;
            }
            if (value === APP_CONTEXT.HOME) {
                result[value] = `${HOME_WIDGET_PANEL_MAX_WIDTH}px`;
                return result;
            }
            result[value] = `${SELECTION_OVERVIEW_WINDOW_SMALL_WIDTH}px`;
            return result;
        }, this.selectionOverviewWidthByContext);
    }
}
